module.exports = __webpack_public_path__ + "static/media/35-1.3b1268ae.mp3";